// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1GNTZ","label":"Section_label__2lvar","contentWrap":"Section_contentWrap__10GQl","footer":"Section_footer__9UspM","footerInner":"Section_footerInner__2gDYL"};